import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { notificationKeys } from '../notificationQueryKeys'
import type { Notification } from '../../types/notificationTypes'

// Optimistic-only while the backend is mocked. When `/api/notifications/read-all`
// ships, set mutationFn to markAllNotificationsRead and add an onError rollback.
export function useMarkAllNotificationsReadMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => Promise.resolve(),
    onMutate: () => {
      qc.setQueryData<Notification[]>(notificationKeys.list(), (current) =>
        (current ?? []).map((notification) => ({ ...notification, isRead: true })),
      )
    },
  })
}
